import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { useLocation  , useParams } from "react-router-dom";
import { base_url } from "./AdminUsers";

const UserStatment = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [userStatements, setUserStatements] = useState([]);
  const [depositList, setDepositList] = useState([]);
  const [withdrawList, setWithdrawList] = useState([]);

  const { id } = useParams();
  const location = useLocation();
  const { id3 } = location.state || {};

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const fetchStatementData = async () => {
      try {
        const auth = localStorage.getItem("admin");
        const res = await axios.get(
          `${base_url}/api/webapi/userStatement/${id}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `${auth}`,
            },
          }
        );

        setUserStatements(res.data.result[0] || []);
        setDepositList(res.data.depositHistory || []);
        setWithdrawList(res.data.withdrawlHistory || []);
      } catch (err) {
        console.error("Error fetching user statement:", err);
      }
    };

    fetchStatementData();
  }, [id3]);

  const renderUserStatementTable = () => (
    <div className="card mt-4">
      <div className="card-header">
        <h4>Chip History</h4>
      </div>
      <div className="card-body p-0">
        <table className="table table-striped text-center">
          <thead>
            <tr>
              <th>Deposit/Withdrawal</th>
              <th>By</th>

              <th>Amount</th>
              <th>Balance</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {userStatements.length > 0 ? (
              userStatements.map((ele, index) => (
                <tr key={index}>
                  <td>
                    Chips {ele.type === "debit" ? "Withdrawal" : "Deposit"}
                  </td>
                  <td>
                    
                    {ele.providerName}
                  </td>
                  <td style={{ color: ele.type === "debit" ? "red" : "green" }}>
                    <b>{ele.amount}</b>
                  </td>
                  <td>{ele.main_balance}</td>
                  <td>{new Date(ele.time).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No user statement data available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderDepositTable = () => (
    <div className="card mt-4">
      <div className="card-header bg-success text-white">
        <h4>Deposit History</h4>
      </div>
      <div className="card-body p-0">
        <table className="table table-striped text-center">
          <thead>
            <tr>
              <th>Amount</th>
              <th>UTR</th>
              <th>Payment Mode</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {depositList.length > 0 ? (
              depositList.map((ele, index) => (
                <tr key={index}>
                  <td style={{ color: ele.status === 1 ? "green" : "red" }}>
              <b>{ele.money}</b>
                    </td>

                  <td>{ele.utr || "N/A"}</td>
                  <td>{ele.type || "N/A"}</td>
                   <td>
                  <b style={{ color: ele.status === 1 ? "green" : "red" }}>
                    {ele.status === 1 ? "Success" : "Pending"}
                  </b>
                </td>

                  <td>{(ele.today).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No deposit data available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderWithdrawTable = () => (
    <div className="card mt-4">
      <div className="card-header bg-danger text-white">
        <h4>Withdrawal History</h4>
      </div>
      <div className="card-body p-0">
        <table className="table table-striped text-center">
          <thead>
            <tr>
              <th>Amount</th>
              <th>Bank Name</th>
              <th>Account Number</th>

              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {withdrawList.length > 0 ? (
              withdrawList.map((ele, index) => (
                <tr key={index}>
                  <td style={{ color: "red" }}><b>{ele.money}</b></td>
                  
                  <td>
                    {ele.name_bank}
                  </td>
                  <td>
                    {ele.stk}
                  </td>
                 <td>
                  <b style={{ color: ele.status === 1 ? "green" : "red" }}>
                    {ele.status === 1 ? "Success" : "Pending"}
                  </b>
                </td>

                  <td>{(ele.today).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No withdrawal data available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );


  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
   <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>
                  User Statement{" "}
                  <img
                    width="35px"
                    height="35px"
                    src="/assets/images/withdraw.png"
                    className="chackImg"
                    alt="icon"
                  />
                </h1>
              </div>
            </div>
          </div>
        </section>

        {renderUserStatementTable()}
        {renderDepositTable()}
        {renderWithdrawTable()}
      </div>
    </div>
  );
};

export default UserStatment;
